import React from 'react';
import ProductContainer from '../../../Componant/Ecommerce/Product';

const Product = () => {
  return (
    <div className='page-body'>
      <ProductContainer />
    </div>
  );
};

export default Product;
